import React, { FC } from "react";
import { noop } from "src/globalConsts";
import { TableCellValue } from "src/requests/table/types";
import {
  FlowioTableCellInput,
  FlowioTableCellInputProps,
} from "../FlowioInput";
import { getArrayValuesFromValue, useGetEntriesBtnMessage } from "./utils";
import TableCellArrayWrapper from "./Wrapper";

const Container: FC<FlowioTableCellInputProps> = (props) => {
  const getEntriesBtnMessage = useGetEntriesBtnMessage();

  const { value, editable = false, onChange = noop, column } = props;

  const arrValue = getArrayValuesFromValue(value);
  const notNullValues = arrValue.filter((val) => val !== null);

  if ((arrValue.length === 1 || notNullValues.length === 1) && !editable) {
    const val = arrValue[0] || notNullValues[0];
    return (
      <FlowioTableCellInput
        {...props}
        value={val as TableCellValue}
        column={{ ...column, isArray: false }}
      />
    );
  }

  return (
    <TableCellArrayWrapper
      {...props}
      values={editable ? arrValue : notNullValues}
      onChange={onChange as (v: TableCellValue[]) => void}
      entriesBtnMessage={getEntriesBtnMessage(
        arrValue,
        notNullValues,
        editable
      )}
    />
  );
};

export default Container;
